var map = {
	"./ico-30-loading.png": "./public/static/assets/ico-30-loading.png",
	"./ico-30-tick.png": "./public/static/assets/ico-30-tick.png",
	"./ico-30-warning.png": "./public/static/assets/ico-30-warning.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./public/static/assets sync recursive ^\\.\\/ico\\-30\\-.*\\.png$";